import type { FormKitNode } from '@formkit/core'

export default (node: FormKitNode): boolean => {
  if (typeof node.value !== 'string') {
    return false
  }

  const value = (node.value).replace(/[\s-]+/gi, '')

  if (!/^[0-9]{10}$/.test(value)) {
    return false
  }

  const controlNumber = parseInt(value.substring(9, 10))
  const sum = [6, 5, 7, 2, 3, 4, 5, 6, 7].reduce((sum, w, i) => sum + parseInt(value.substring(i, i + 1)) * w, 0)

  return sum % 11 === controlNumber
}